var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55333 0.803166C3.84622 0.510273 4.3211 0.510273 4.61399 0.803166C4.90688 1.09606 4.90688 1.57093 4.61399 1.86383L2.56098 3.91683H11.417C11.8312 3.91683 12.167 4.25262 12.167 4.66683C12.167 5.08104 11.8312 5.41683 11.417 5.41683H2.56099L4.61399 7.46983C4.90688 7.76273 4.90688 8.2376 4.61399 8.53049C4.3211 8.82339 3.84622 8.82339 3.55333 8.53049L0.219995 5.19716C-0.0728979 4.90427 -0.0728979 4.42939 0.219995 4.1365L3.55333 0.803166ZM8.61366 7.46967C8.32077 7.17678 7.8459 7.17678 7.553 7.46967C7.26011 7.76256 7.26011 8.23744 7.553 8.53033L9.60601 10.5833H0.75C0.335786 10.5833 0 10.9191 0 11.3333C0 11.7475 0.335786 12.0833 0.75 12.0833H9.60601L7.553 14.1363C7.26011 14.4292 7.26011 14.9041 7.553 15.197C7.8459 15.4899 8.32077 15.4899 8.61366 15.197L11.947 11.8637C12.2399 11.5708 12.2399 11.0959 11.947 10.803L8.61366 7.46967Z",
    fill: "#754CFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.7780c4a286300ef19967ea9292c5e4da.svg";
export { ForwardRef as ReactComponent };